/**
 * Converts a string to PascalCase (equivalent to _.upperFirst(_.camelCase(str))).
 * Examples: 'hello world' → 'HelloWorld', 'foo-bar_baz' → 'FooBarBaz'
 */
export const toPascalCase = (str) => {
	if (!str) return ''
	return str
		.toLowerCase()
		.replace(/[-_\s]+(.)/g, (_, c) => c.toUpperCase())
		.replace(/^(.)/, (c) => c.toUpperCase())
}

/**
 * Converts a string to Title Case (equivalent to _.startCase(_.toLower(str))).
 * Example: 'HELLO WORLD' → 'Hello World'
 */
export const toTitleCase = (str) => {
	if (!str) return ''
	return str
		.toLowerCase()
		.replace(/(?:^|\s)\S/g, (c) => c.toUpperCase())
}
